import get from 'lodash/get';
import type { RxCollection, RxDocument } from 'rxdb';

export default function getPrimaryKeyFromDatabaseEntry<DocType>(
  entry: DocType | RxDocument<DocType>,
  rxCollection: RxCollection<DocType>,
): string {
  // claude eslint: lodash `get` returns `any`; primaryPath always resolves to a string value in our schema.
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  return get(entry, rxCollection.schema.primaryPath) as string;
}
